<template>
    <main-layout>
        <div id="applications" class="page animated fadeIn">
            <v-container fluid class="pa-0">
                <v-row justify="space-between">
                    <v-col cols="12">
                        <h1 class="mb-0">Applications</h1>
                    </v-col>
                    <v-col cols="12" class="text-center text-lg-right pa-0 pa-lg-3">
                        <form-dialog
                                :form-title="formTitle"
                                activator-text="Add Application"
                                :dialog="dialog"
                                :success-message="successMessage"
                                :form-loading="formLoading"
                                :data-sent="dataSent"
                                :valid="valid"
                                @dialogOpen="dialog = true"
                                @dialogClose="handleDialogClose"
                                @formSubmit="handleAppSubmit"
                        >
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field label="Name" :rules="rules.name" v-model="editApp.name" required></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea
                                            name="description"
                                            label="Description"
                                            hint="Short App Description"
                                            v-model="editApp.description"
                                    ></v-textarea>
                                    <div v-if="editedIndex > -1">
                                        <v-text-field label="Key" readonly :value="editApp.key"></v-text-field>
                                    </div>
                                </v-col>
                            </v-row>
                        </form-dialog>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="12">
                        <template v-if="getApps.length">
                            <application v-for="app in getApps" :key="app.id" :app="app" @edit="handleEditApp"></application>
                        </template>
                        <template v-else>
                            <h2 class="text-white">There is no apps yet.</h2>
                        </template>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </main-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../../store';
import Application from '../common/Application.vue';
import FormDialog from '../common/FormDialog.vue';
import MainLayout from '../layouts/MainLayout.vue';

export default {
  data() {
    return {
      valid: true,
      apps: [],
      newApp: {
        name: '',
        description: '',
      },
      editApp: {
        name: '',
        description: '',
      },
      editedIndex: -1,
      dialog: false,
      rules: {
        name: [
          (value) => Boolean(value) || 'Required.',
          (value) => (value || '').length <= 255 || 'Max 255 characters',
        ],
      },
      formLoading: false,
      dataSent: false,
      successMessage: 'Data has been saved!',
    };
  },
  components: {
    MainLayout,
    Application,
    FormDialog,
  },
  computed: {
    formTitle() {
      return this.editedIndex > -1 ? 'Edit Application' : 'New Application';
    },
    ...mapGetters('applications', ['getApps']),
  },
  methods: {
    handleAppSubmit(form) {
      if (!form.validate()) {
        return;
      }
      this.formLoading = true;
      if (this.editedIndex > -1) {
        store.dispatch('applications/updateApp', this.editApp);
      } else {
        store.dispatch('applications/createApp', this.editApp);
      }
      this.formLoading = false;
      this.dataSent = true;
      setTimeout(() => {
        this.handleDialogClose(form);
      }, 2000);
    },
    handleEditApp(item) {
      this.editedIndex = this.getApps.indexOf(item);
      this.editApp = { ...item };
      this.dialog = true;
    },
    handleDialogClose(form) {
      this.dialog = false;
      this.dataSent = false;
      this.$nextTick(() => {
        form.resetValidation();
        this.editApp = { ...this.newApp };
        this.editedIndex = -1;
      });
    },
  },
  async mounted() {
    await store.dispatch('applications/saveAppsStore');
  },
  name: 'Applications',
};
</script>

<style lang="sass"></style>
